import React from "react"
import styled, { ThemeProvider } from "styled-components"
import { connect } from "react-redux"

import theme from "../theme"

import {
  Reboot,
  MaxWidthContainer,
  Row,
  selectHeader,
} from "@hurleymc/components"

import Head from "./head"
import Header from "./header"
import Footer from "./footer"

import "../scss/app.scss"

const Shell = styled.div`
  display: block;
  min-height: 100%;
  min-height: 100vh;

  .nav-search {
    visibility: hidden;
  }
`

const Content = styled(MaxWidthContainer)`
  background: white;
  background-color: white;
  min-height: 100%;
  min-height: 100vh;
`

const Main = styled.main`
  width: 100%;
`

const withState = connect(state => ({ header: selectHeader(state) }))

const Layout = withState(props => {
  const { children } = props
  return (
    <ThemeProvider theme={theme}>
      <Shell>
        <Reboot />
        <Head />
        <Header {...props} />
        <Content className={"content"}>
          <Row>
            <Main>
              <h1 style={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                borderWidth: 0,
              }}>Hurley Medical Education</h1>
              {children}
            </Main>
          </Row>
        </Content>
        <Footer />
      </Shell>
    </ThemeProvider>
  )
})

export default Layout
